import { render, staticRenderFns } from "./FieldTranslator.vue?vue&type=template&id=2dffe0e0&"
import script from "./FieldTranslator.vue?vue&type=script&lang=js&"
export * from "./FieldTranslator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports